import { useMemo, useState } from 'react';
import {
  List,
  TextField,
  FunctionField,
  useTranslate,
} from 'react-admin';
import { CustomDatagrid, CrudListActions, RowActionsMenu } from '@/components/common';
import { compactListSx } from '@/components/common/compactListSx';
import {
  CollapsibleFilterPanel,
  FilterExpandContext,
} from '@/components/common/CollapsibleFilterPanel';
import { CustomTextInputFilter } from '@/components/common/CustomFilters';

// Indexed by JS getDay(): 0 = Sunday
const WEEKDAY_SHORT = ['D', 'L', 'M', 'X', 'J', 'V', 'S'];

export const DepartmentList = () => {
  const translate = useTranslate();
  const [filtersExpanded, setFiltersExpanded] = useState(false);
  const filterExpandValue = useMemo(
    () => ({ expanded: filtersExpanded, setExpanded: setFiltersExpanded }),
    [filtersExpanded]
  );

  const filters = useMemo(
    () => [
      <CollapsibleFilterPanel key="filters" source="_cfp" alwaysOn alwaysVisibleCount={0}>
        <CustomTextInputFilter
          source="q"
          label={translate('common.filters.search', { _: 'Buscar' })}
          alwaysOn
        />
      </CollapsibleFilterPanel>,
    ],
    [translate]
  );

  return (
    <FilterExpandContext.Provider value={filterExpandValue}>
      <List
        sx={compactListSx}
        filters={filters}
        actions={<CrudListActions exportColumns={['name', 'description', 'organization_id', 'weekdays']} />}
        sort={{ field: 'department_id', order: 'DESC' }}
        exporter={false}
      >
        <CustomDatagrid primarySource="name" secondarySource="description" bulkActionButtons={false}>
          <RowActionsMenu label="" sortable={false} />
          <TextField source="name" />
          <TextField source="description" />
          <FunctionField
            source="weekdays"
            sortable={false}
            render={(record: any) =>
              Array.isArray(record?.weekdays)
                ? record.weekdays.map((d: number) => WEEKDAY_SHORT[d] ?? d).join(' ')
                : ''
            }
          />
        </CustomDatagrid>
      </List>
    </FilterExpandContext.Provider>
  );
};

export default DepartmentList;
